import * as React from "react";
import {
  ConditionSet,
  ICheckboxesElement,
  IRadioButtonsElement,
  ISelectElement,
} from "@graffer-inc/form-schema";

export const IfConditionsViewer: React.FC<{
  ifConditions: ConditionSet;
  ifCandidates: Array<
    ISelectElement | ICheckboxesElement | IRadioButtonsElement
  >;
}> = ({ ifConditions, ifCandidates }) => {
  const conds = ifConditions.conditions;
  return (
    <>
      {conds.map((c, index) => {
        const selected = ifCandidates.find((s) => s.id === c.id);
        return (
          <div key={index} className="columns is-vcentered">
            <div className="column is-narrow">
              <div className="field has-text-weight-bold">
                {ifCandidates.find((f) => f.id === c.id)!.label.text}
              </div>
            </div>
            <div className="column is-narrow is-paddingless">
              <p>が</p>
            </div>
            <div className="column is-narrow">
              <div className="field has-text-weight-bold">
                {selected!.enum.find((e) => e.value === c.match.const)!.text}
              </div>
            </div>
            <div className="column is-narrow">のとき、</div>
          </div>
        );
      })}
    </>
  );
};
